import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../../atoms';

import { TreatmentHistoryTable } from './TreatmentHistoryTable';

export const TreatmentHistorySection = () => {
  const currentPlan = useAtomValue(selectedPlanAtom);

  // Only render if treatmentHistoryV2 exists
  if (!currentPlan?.treatmentHistoryV2) {
    return null;
  }

  return <TreatmentHistoryTable data={currentPlan.treatmentHistoryV2} />;
};
